export default { sha: '695442549e36ffe605372f4a57383c6f410fbb13', buildNumber: 'undefined' }
